import LocomotiveScroll from 'locomotive-scroll';
//import { gsap, TweenLite, TweenMax, Linear, Back, Elastic, TimelineMax, TimelineLite, Power1, Power4 , Power2, Power3} from "gsap";
import { gsap, TweenMax, Power1, Power2, Power3} from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { Draggable } from "gsap/Draggable";
import { SplitText } from "gsap/SplitText";
//import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
//import { CustomEase } from "gsap/CustomEase";
import { InertiaPlugin } from "gsap/InertiaPlugin";
//import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import barba from '@barba/core';
//gsap.registerPlugin(CSSRulePlugin, DrawSVGPlugin, Draggable, SplitText,ScrollToPlugin, ScrollTrigger, MorphSVGPlugin, CustomEase, InertiaPlugin, TweenMax);


gsap.registerPlugin(CSSRulePlugin, Draggable, SplitText, ScrollTrigger, TweenMax, InertiaPlugin, MorphSVGPlugin);



(function( $ ) {


    var locoScroll;
	function initScroll(){

		//Bij een barba transitie wordt initScroll opnieuw aangeroepen. Zonder destroy
		//blijft de oude instantie (met de oude scroll limit) meeluisteren.
		if(locoScroll){
			try{
				locoScroll.destroy();
			}
			catch(e){}
			locoScroll = null;
		}

		initSplitText();
		let options = {
			el: document.querySelector('.scroller'),
			smooth: true,
			lerp:0.15,
			multiplier:1,
			touchMultiplier:2,
			getSpeed: true,
			getDirection: true,
			smoothTouch: false,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			//Op mobiel geen smooth scroll: locomotive valt dan terug op native
			//scrollen van het venster. Zie _global.scss, waar html/body en main
			//op mobiel het venster laten scrollen in plaats van main.
			smartphone: {
				smooth: false
			},
			reloadOnContextChange: true
		}

		locoScroll = new LocomotiveScroll(options);
        

		//locoScroll.on("scroll", ScrollTrigger.update);
		locoScroll.on("scroll", updateScroll);

		
		//locoScroll.on("scroll", menuspecialsfixedScroll);


		ScrollTrigger.scrollerProxy(".scroller", {
			scrollTop(value) {
				return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
			},
			getBoundingClientRect() {
				return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
			}
		});
		ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
		ScrollTrigger.refresh();
        initParallax();
        initSliders();
		initLazyLoad();
		initCarAnimation();
		watchScrollHeight();
		checkNavFit(); //ook na een barba-wissel: de header wordt dan opnieuw gerenderd
	}

	//SCROLL HEIGHT
	//Beelden worden lazy ingeladen, waardoor de pagina hoger wordt nadat locomotive
	//zijn scroll limit al berekend heeft. Zonder update kun je dan niet tot onderaan scrollen.
	var updateScrollTimeout;
	var scrollHeightObserver;
	var lastScrollHeight = 0;

	function updateScrollHeight(delay){
		if(!locoScroll){
			return;
		}
		if(typeof delay === "undefined"){
			delay = 120;
		}
		clearTimeout(updateScrollTimeout);
		updateScrollTimeout = setTimeout(function(){
			if(locoScroll){
				locoScroll.update();
			}
		}, delay);
	}

	function watchScrollHeight(){
		var scroller = document.querySelector('.scroller');
		if(!scroller){
			return;
		}

		lastScrollHeight = scroller.offsetHeight;

		if(scrollHeightObserver){
			scrollHeightObserver.disconnect();
		}

		if(typeof ResizeObserver === "undefined"){
			return;
		}

		scrollHeightObserver = new ResizeObserver(function(){
			var height = scroller.offsetHeight;
			if(height === lastScrollHeight){
				return;
			}
			lastScrollHeight = height;
			updateScrollHeight();
		});
		scrollHeightObserver.observe(scroller);
	}

	$(window).on("load", function(){
		updateScrollHeight(0);
	});


    function updateScroll(args){
		var y = args.scroll.y;
		var x = args.scroll.x;
		ScrollTrigger.update();
		headerScroll(args);
		lazyLoad(y, x);
	}

	function initLazyLoad(){
		lazyLoad(0,0);
	}

	//LAZY LOAD
	function lazyLoad(y,x){
		var winH = window.innerHeight;
		var winW = window.innerWidth;


		$("img[data-lazy-src]").each(function(i){

			var loaded = false;
			if($(this).hasClass("-loaded")){
				var loaded = true;
			}
			//getBoundingClientRect is altijd t.o.v. het scherm, zowel bij de smooth
			//scroll (die de secties transformt) als bij native scrollen op mobiel.
			//offset() is documentgebaseerd en werkt daar niet.
			var rect = this.getBoundingClientRect();
			if((rect.top < (winH*1)) && (rect.bottom > (winH*-0.02)) && (rect.left < (winW*1.02)) && (rect.right > (winW*-0.02))){
				$(this).addClass("-in-view");
				if(!loaded){
					var lazysrc = $(this).attr("data-lazy-src");
					var lazysrcmobile = lazysrc;
					if ($(this).attr('data-lazy-src-mobile') !== undefined) {
						lazysrcmobile = $(this).attr("data-lazy-src-mobile");
					}
					var src = $(this).attr("src");
					if(winW < 767){
						lazysrc = lazysrcmobile;
					}
					if(lazysrc != src){
						$(this).on("load", function() {
							$(this).addClass("-loaded");
							updateScrollHeight();
						}).attr("src", lazysrc);
					}
					else{
						$(this).addClass("-loaded");
					}
				}
			}
			else{
				$(this).removeClass("-in-view");
			}
			
		});
	}

	$(window).on("resize", function(){
		initLazyLoad();
		updateScrollHeight();
	});

	let scrollDirection = "down";
	let pxScrolledStart = 0;
	let pxScrolledInDirection = 0;
	
	function headerScroll(args){
		
        let scrollTop = args.scroll.y;
        var header = $(".header");
		var winW = $(window).width();
		
		if(scrollDirection == args.direction){
			if(scrollDirection == "down"){
				pxScrolledInDirection = args.scroll.y-pxScrolledStart;
			}
			else{
				pxScrolledInDirection = pxScrolledStart-args.scroll.y;
			}
			
		}
		else{
			scrollDirection = args.direction;
			pxScrolledStart = args.scroll.y;
			pxScrolledInDirection = 0;
		}

		//Achtergrond aan zodra de pagina van bovenaf weg is; de overgang zelf
		//zit in de css op .header .bg.
		//In de native modus (mobiel) geeft locomotive de stand van het vorige
		//event door, daarom pageYOffset erbij; bij smooth scroll is die altijd 0.
		var currentTop = Math.max(scrollTop, window.pageYOffset || 0);
		if(currentTop > 24){
			header.addClass("-scrolled");
		}
		else{
			header.removeClass("-scrolled");
		}

		
		/*
		if(winW > 767){
			if(scrollTop < 160){
				gsap.set(header, {height:80-(scrollTop*0.1)});
				gsap.set(headerBG, {opacity:(scrollTop/160)});
			}
			else{
				gsap.set(header, {height:64});
				gsap.set(headerBG, {opacity:1});
			}
		}
		else{
			if(scrollTop < 160){
				gsap.set(header, {height:72-(scrollTop*0.075)});
				gsap.set(headerBG, {opacity:(scrollTop/160)});
			}
			else{
				gsap.set(header, {height:60});
				gsap.set(headerBG, {opacity:1});
			}
		}*/
		

    }
	

    function headerScrollReset(){
        /*var header = $(".header");
        var headerBG = $(".header .bg2");
		var winW = $(window).width();

		if(winW > 767){
        	gsap.to(header, {height:64,duration:0.4,ease:Power2.easeInOut});
		}
		else{
			gsap.to(header, {height:64,duration:0.4,ease:Power2.easeInOut});
		}
        gsap.to(headerBG, {opacity:0,duration:0.4,ease:Power2.easeInOut});*/
    }




    function initParallax(){

    const sequence = document.querySelector(".car-sequence");

    if (!sequence) {
        return;
    }

    const frames = sequence.querySelectorAll(".car-sequence__frame");
    let currentFrame = 0;

    ScrollTrigger.create({
        trigger: sequence.closest(".flex-3d_model"),
        scroller: ".scroller",
        start: "100% bottom",
		end: "bottom 50%",
		scrub: true,
		invalidateOnRefresh: true,

        onUpdate: (self) => {

            const frame = Math.min(
                frames.length - 1,
                Math.round(self.progress * (frames.length - 1))
            );

            if (frame !== currentFrame) {
                frames[currentFrame].classList.remove("is-active");
                frames[frame].classList.add("is-active");
                currentFrame = frame;
            }
        }
    });

}

    



    //BARBA PAGE TRANSITIONS
	barba.init({
		cacheIgnore: false,
		prefetchIgnore: false,
		transitions: [{
			name: 'opacity-transition',
			leave(data) {
                //headerScrollReset();
                
                //console.log(data);
                const tl = gsap.timeline();

                tl.to(".main-menu li.-active .line", {
                    left: "100%",
					width: "0%",
                    duration:0.3,
                    ease:Power2.easeInOut
                });

				const tl2 = gsap.timeline();

                tl2.to(".scroller", {
                    opacity:0,
                    duration:0.3,
                    ease:Power2.easeInOut
                });

				
                
                return tl2;

                
			},
            beforeEnter(data){
                
                
                
                //initNav(data.next.namespace);
				//gsap.set(data.next.container, { opacity:0});
                //gsap.set(data.next.container, { y:"300px"});
			},
			enter(data) {

				gsap.fromTo(
					$(".main-menu li.-active .line"), 
					{"width":0},
					{"width":"100%", duration:0.5, delay:0, ease:Power2.easeOut},
				);
                
                //locoScroll.destroy();
                
                const tl2 = gsap.timeline();
                /*tl2.to(".page-transition .slide", {
                    y:"-100%",
                    duration:0.6,
                    delay:0,
                    ease:Power2.easeInOut
                });
				/*const tl = gsap.timeline(); */
                tl2.from(".scroller", {
                    opacity:0,
                    duration:0.3,
                    delay:0,
                    ease:Power2.easeInOut
                }); 
				
                
                
			},
			after() {
				initScroll();
				//initNav2();
				initSliders();
				//headerScrollReset();
                //setTimeout(function(){
                    
                //},1000);
                //gsap.set(".page-transition .slide", { height:"100%", y:"100%", delay:0.6});
			},
			afterEnter(data) {
				const videos = data.next.container.querySelectorAll('video');
				videos.forEach(video => {
					video.play().catch(error => {
					// Handle autoplay policy restrictions gracefully
					console.log("Autoplay prevented:", error);
					});
				});
			}
		}]
	});




   /*SPLIT TEXT */
	var splitArray = [];
	var split;
	var split2;
	var split3;
	function initSplitText() {
		var winW = $(window).width();
		splitArray = [];
		if(winW < 1024){
			return false;
		}
		$(".-split-lines").each(function(i, el){
			split3 = new SplitText(el, { type: "lines", linesClass: "-l-inside" });
		});

		//split text
		$(".-text-animation").each(function(i, el){
			var staggerAttr = $(el).attr('text-animation-stagger');
			if (typeof staggerAttr !== 'undefined' && staggerAttr !== false) {
				var stagger = staggerAttr;
			}
			else{
				var stagger = 0.08;
			}

			var delayAttr = $(el).attr('text-animation-delay');
			if (typeof delayAttr !== 'undefined' && delayAttr !== false) {
				var delay = delayAttr;
			}
			else{
				var delay = 0;
			}

			var durationAttr = $(el).attr('text-animation-duration');
			if (typeof durationAttr !== 'undefined' && durationAttr !== false) {
				var duration = durationAttr;
			}
			else{
				var duration = 0.2;
			}

			var positionAttr = $(el).attr('text-animation-position');
			if (typeof positionAttr !== 'undefined' && positionAttr !== false) {
				var position = positionAttr;
			}
			else{
				var position = "top 100%";
			}


			if($(el).hasClass("-lines")){
				//split2 = nestedLinesSplit($(el), {type:"lines", linesClass: "-l-outside" });
				//split = nestedLinesSplit($(el), {type:"lines", linesClass: "-l-inside" });
				//splitArray.push(split);
				if($("p",el).length){
					el = $("p", el);
				}
				split = new SplitText(el, { type: "lines", linesClass: "-l-inside" });


				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $(el)[0],
						start: position,
						scroller: ".scroller",
						end: "bottom top",
						//onToggle: self => gsap.to(el, {opacity: self.isActive ? 1 : 0}),
						//toggleActions: "play none none none",
						markers: false,
						stagger: stagger,
						ease: "power3.easeIn"
					}
				});


				splitTimeline.from(split.lines, {
					duration: duration,
					opacity: 0,
					y: "40%",
					scale: 1,
					yoyo: false,
					stagger: stagger,
					//toggleActions: "play none none none",
					delay:delay,
					ease: "power3.easeIn",
				});
			}
			if($(el).hasClass("-words")){
				//const split2 = nestedLinesSplit($(el), {type:"words", wordsClass: "-w-outside" });
				//const split = nestedLinesSplit($(el), {type:"words", wordsClass: "-w-inside" });
				if($("p",el).length){
					el = $("p", el);
				}

				var split = new SplitText(el, { type: "words", linesClass: "-w-inside" });



				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $(el)[0],
						start: position,
						scroller: ".scroller",
						end: "bottom top",
						onToggle: self => gsap.to(el, {opacity: self.isActive ? 1 : 0}),
						toggleActions: "play none none none",
						markers: false,
						stagger: stagger,
						ease: "power3.easeInOut"
					}
				});


				splitTimeline.from(split.words, {
					duration: duration,
					opacity: 0,
					y: "30%",
					scale: 1,
					yoyo: false,
					stagger: stagger,
					delay:delay,
					ease: "power3.easeInOut",
				});


			}
		});


	}



	//menu link animation
	$("body").on("click", ".main-menu .menu-list li a", function(){
		var b = $(".main-menu .menu-list li.-active a .l");
		gsap.to(b, {width:"0%",duration:0.3, ease: Power2.easeOut});
		var l = $(".l", this);
		gsap.to(l, {width:"100%",duration:0.3, ease: Power2.easeOut});
	});

	/////////////
	//mega-menu (desktop)
	/////////////
	//Eén paneel met alle dropdown-groepen. Hover of focus op een menu-item met
	//dropdown opent het en markeert de bijbehorende kolom.
	var megaCloseTimer;

	//Het paneel hangt in het menu-item zelf; zonder correctie valt het bij de
	//rechtse items buiten de header. Daarom schuiven we het naar links tot het past.
	function positionMega($li){
		var panel = $li.children(".mega-menu").get(0);
		var header = $("header.header").get(0);
		if(!panel || !header){
			return;
		}
		panel.style.left = "0px";
		var headerBox = header.getBoundingClientRect();
		var itemBox = $li.get(0).getBoundingClientRect();
		var panelBox = panel.getBoundingClientRect();
		var overflowRight = panelBox.right - headerBox.right;
		if(overflowRight > 0){
			//Niet verder opschuiven dan de linkerrand van de header.
			panel.style.left = "-" + Math.round(Math.min(overflowRight, itemBox.left - headerBox.left)) + "px";
		}
	}

	function openMega(index){
		clearTimeout(megaCloseTimer);
		var $header = $("header.header");
		var $li = $header.find('.main-menu > li[data-dropdown="' + index + '"]');
		if(!$li.length || !$li.children(".mega-menu").length){
			closeMega(0);
			return;
		}
		$header.addClass("-mega-open");
		$header.find(".main-menu > li").removeClass("-hover").children("a[aria-haspopup]").attr("aria-expanded", "false");
		$header.find(".mega-menu").attr("aria-hidden", "true");
		$li.addClass("-hover").children("a").attr("aria-expanded", "true");
		$li.children(".mega-menu").attr("aria-hidden", "false");
		positionMega($li);
	}

	function closeMega(delay){
		clearTimeout(megaCloseTimer);
		megaCloseTimer = setTimeout(function(){
			var $header = $("header.header");
			$header.removeClass("-mega-open");
			$header.find(".mega-menu").attr("aria-hidden", "true");
			$header.find(".main-menu > li").removeClass("-hover").children("a[aria-haspopup]").attr("aria-expanded", "false");
		}, delay || 0);
	}

	$("body").on("mouseenter focusin", "header.header .main-menu > li.-has-dropdown", function(){
		openMega($(this).attr("data-dropdown"));
	});
	//Naar het logo, de knoppen of een item zonder dropdown: paneel dicht.
	$("body").on("mouseenter focusin", "header.header .main-menu > li:not(.-has-dropdown), header.header .left-side, header.header .right-side", function(){
		closeMega(120);
	});
	$("body").on("mouseenter focusin", "header.header .mega-menu", function(){
		clearTimeout(megaCloseTimer);
	});
	$("body").on("mouseleave", "header.header", function(){
		closeMega(180);
	});
	$("body").on("focusout", "header.header", function(e){
		if(!e.relatedTarget || !$(e.relatedTarget).closest("header.header").length){
			closeMega(0);
		}
	});
	$(document).on("keydown", function(e){
		if(e.key === "Escape"){
			closeMega(0);
		}
	});
	//Pijltje omlaag op een menu-item: naar de eerste link in zijn kolom.
	$("body").on("keydown", "header.header .main-menu > li.-has-dropdown > a", function(e){
		if(e.key !== "ArrowDown"){
			return;
		}
		e.preventDefault();
		var index = $(this).parent().attr("data-dropdown");
		openMega(index);
		$('header.header .main-menu > li[data-dropdown="' + index + '"] .mega-menu__links a').first().trigger("focus");
	});
	//Past de desktop-navigatie niet in de header (lange labels, andere taal),
	//dan het hamburgermenu tonen in plaats van dat items over elkaar lopen.
	function checkNavFit(){
		var $header = $("header.header");
		var middle = $header.find(".middle-side").get(0);
		var nav = $header.find(".main-menu").get(0);
		if(!middle || !nav){
			return;
		}
		//Eerst zonder de class meten; dit gebeurt in één taak, dus zonder flits.
		$header.removeClass("-nav-overflow");
		var cs = getComputedStyle(middle);
		if(cs.display === "none"){
			return; //onder $br-header-nav regelt de css het hamburgermenu al
		}
		var available = middle.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
		//Niet scrollWidth gebruiken: de dropdown-panelen hangen absoluut in de
		//menu-items en tellen daarin mee. De items zelf krimpen niet (nowrap),
		//dus hun breedte plus de tussenruimte is de echte benodigde breedte.
		var $items = $(nav).children("li");
		var gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
		var needed = gap * Math.max(0, $items.length - 1);
		$items.each(function(i, el){
			needed += el.getBoundingClientRect().width;
		});
		if(needed > available + 1){
			$header.addClass("-nav-overflow");
			closeMega(0);
		}
	}
	$(window).on("resize", function(){
		checkNavFit();
		var $open = $("header.header .main-menu > li.-hover");
		if($open.length){
			positionMega($open.first());
		}
	});
	if(document.fonts && document.fonts.ready){
		document.fonts.ready.then(checkNavFit);
	}

	//Een dropdown-item zonder eigen pagina (#) klapt alleen het paneel open.
	$("body").on("click", 'header.header .main-menu > li.-has-dropdown > a[href="#"]', function(e){
		e.preventDefault();
		openMega($(this).parent().attr("data-dropdown"));
	});


    /////////////
    //mobile menu
    /////////////

    $("body").on("click", ".responsive-menu:not(.-open)", function(){
		openResponsiveMenu();
    });
	$("body").on("click", ".responsive-menu.-open", function(){
        closeResponsiveMenu();
    });
	$("body").on("click", ".mobile-menu div[data-barba-link]", function(e){
		const href = $(this).attr('href');
		closeResponsiveMenu();
		if (
			!href ||
			href.startsWith('#') ||
			href.startsWith('mailto:') ||
			href.startsWith('tel:') ||
			this.target === '_blank'
		) {
			return;
		}
		setTimeout(function () {
			barba.go(href);
		}, 300);
        
    });
	$("body").on("click", ".mobile-menu .mobile-menu-blur", function(){
        closeResponsiveMenu();
    });
	//Submenu uitklappen; de link zelf blijft naar de pagina gaan.
	$("body").on("click", ".mobile-menu .toggle", function(){
		var $li = $(this).closest("li");
		var open = !$li.hasClass("-open");
		$li.toggleClass("-open", open);
		$(this).attr("aria-expanded", open ? "true" : "false");
		gsap.to($li.children(".sub"), {height: open ? "auto" : 0, duration:0.4, ease: Power2.easeInOut});
	});

	function openResponsiveMenu(){
		$(".responsive-menu").addClass("-open");
		$(".mobile-menu-scroll").scrollTop(0);
		gsap.set($(".mobile-menu"), {opacity:1,pointerEvents:"all",visibility:"visible"});
		gsap.to($("header.header .mobile-menu-blur"), {opacity:1,duration:1, ease: Power2.easeOut});
		gsap.to($("header.header .mobile-menu-bg"), {y:0, duration:1, ease: Power2.easeInOut});
		gsap.to($("main"), {y:0,scale:1, duration:1, ease: Power2.easeInOut});
		//Alleen de hoofditems animeren; de submenu-items zitten ingeklapt in .sub.
		//Beginstand eerst direct zetten met gsap.set, zodat de titels al onder de
		//rand van hun .item staan (yPercent:130) voordat het menu zichtbaar wordt:
		//nooit een halve regel in beeld. yPercent rekent met de hoogte van de titel
		//zelf, ongeacht de rijhoogte of lettergrootte.
		var $titles = $(".mobile-menu .menu-list .item .title");
		var $toggles = $(".mobile-menu .menu-list .toggle");
		gsap.set($titles, {yPercent:130, opacity:0});
		gsap.set($toggles, {opacity:0});
		gsap.to($titles, {yPercent:0, opacity:1, duration:0.9, delay:0.35, stagger:0.06, ease:"power3.out", overwrite:true});
		gsap.to($toggles, {opacity:1, duration:0.6, delay:0.45, stagger:0.06, ease:"power2.out", overwrite:true});
	}

	function closeResponsiveMenu(){
		$(".responsive-menu").removeClass("-open");
		gsap.to($("header.header .mobile-menu-blur"), {opacity:0,duration:1, ease: Power2.easeInOut});
		gsap.to($("header.header .mobile-menu-bg"), {y:"-100%",duration:1, delay:0, ease: Power2.easeInOut});
		//De transform op main moet er na afloop af: een transform maakt main het
		//containing block, waardoor de fixed header op mobiel toch mee scrollt.
		gsap.to($("main"), {y:0,scale:1,duration:1, ease: Power2.easeInOut, onComplete:function(){
			gsap.set($("main"), {clearProps:"transform"});
		}});
		gsap.to($(".mobile-menu .menu-list .item .title"), {yPercent:130, opacity:0, duration:0.35, stagger:0.02, ease:"power2.in", overwrite:true});
		gsap.to($(".mobile-menu .menu-list .toggle"), {opacity:0, duration:0.25, ease:"power2.in", overwrite:true});
		//visibility:hidden zodat de knoppen in het dichte menu niet via tab
		//bereikbaar zijn; uitgeklapte submenu's gaan weer dicht.
		gsap.set($(".mobile-menu"), {opacity:0,pointerEvents:"none",visibility:"hidden",delay:1, onComplete:function(){
			$(".mobile-menu .menu-list > li.-open").removeClass("-open").find(".toggle").attr("aria-expanded", "false");
			gsap.set($(".mobile-menu .sub"), {height:0});
		}});

	}
	
   
    
    



    //modal 

    function openModal(modalName){
		var modal = $("#modal__overlay");
		gsap.set(
			$(".modal-container", modal), 
			{opacity:0, zIndex:1},
		);
		gsap.set($(modal), {"display": "block"});
		gsap.fromTo(
			$(".bg", modal), 
			{opacity:0},
			{opacity:1, duration:1, delay:0, ease:Power3.easeOut},
		);
		gsap.fromTo(
			$("#modal-"+modalName, modal), 
			{opacity:0, zIndex:11, marginTop:"10px"},
			{opacity:1, duration:1, zIndex:11, marginTop:"0px", delay:0.5, ease:Power3.easeOut},
		);
	}

	function closeModal(){
		var modal = $("#modal__overlay");
		gsap.to(
			$(".bg", modal), 
			{opacity:0, delay:0, duration:0.5, ease:Power3.easeOut, onComplete:function(){ gsap.set($(modal), {"display": "none"}) }},
		);
		gsap.to(
			$(".modal-container", modal), 
			{opacity:0, duration:0.5, delay:0, zIndex:1, marginTop:"10px", ease:Power3.easeOut},
		);
		
	}

    //COOKIES
	//De keuze staat in een cookie (zie functions/cookies.php) en niet in localStorage,
	//zodat PHP hem ook kan lezen. Scripts met type="text/plain" en data-cookie-category
	//draaien pas zodra de bezoeker die categorie toestaat; iframes met data-cookie-src
	//krijgen hun src dan pas. Zonder toestemming gebeurt er dus niets.
	var $cookieBar = $("#cookies__overlay");

	if($cookieBar.length){

		var consentName    = $cookieBar.attr("data-consent-cookie") || "ams_consent";
		var consentVersion = parseInt($cookieBar.attr("data-consent-version"), 10) || 1;
		var consentDays    = parseInt($cookieBar.attr("data-consent-days"), 10) || 182;
		var consentCats    = ["analytics", "marketing"];

		function readConsent(){
			var match = document.cookie.match(new RegExp("(?:^|; )" + consentName + "=([^;]*)"));
			if(!match){ return null; }
			try{
				var data = JSON.parse(decodeURIComponent(match[1]));
				//Zijn de categorieën gewijzigd, dan is oude toestemming niet meer geldig.
				if(!data || parseInt(data.v, 10) !== consentVersion){ return null; }
				return data;
			}
			catch(e){ return null; }
		}

		function writeConsent(state){
			var data = {v:consentVersion, necessary:true, ts:Math.round(Date.now()/1000)};
			consentCats.forEach(function(cat){ data[cat] = !!state[cat]; });

			var secure = (location.protocol === "https:") ? "; Secure" : "";
			document.cookie = consentName + "=" + encodeURIComponent(JSON.stringify(data)) +
				"; path=/; max-age=" + (consentDays * 24 * 60 * 60) + "; SameSite=Lax" + secure;

			applyConsent(data);
			return data;
		}

		function applyConsent(data){
			$("script[type='text/plain'][data-cookie-category]").each(function(){
				if(!data[$(this).attr("data-cookie-category")]){ return; }
				var old = this;
				var script = document.createElement("script");
				for(var i = 0; i < old.attributes.length; i++){
					var attr = old.attributes[i];
					if(attr.name === "type" || attr.name === "data-cookie-category"){ continue; }
					script.setAttribute(attr.name, attr.value);
				}
				script.text = old.text;
				old.parentNode.replaceChild(script, old);
			});

			$("[data-cookie-src][data-cookie-category]").each(function(){
				if(!data[$(this).attr("data-cookie-category")]){ return; }
				this.src = $(this).attr("data-cookie-src");
				$(this).removeAttr("data-cookie-src");
			});

			document.dispatchEvent(new CustomEvent("ams-consent", {detail:data}));
		}

		function syncToggles(data){
			$cookieBar.find("[data-consent-category]").each(function(){
				var cat = $(this).attr("data-consent-category");
				if(cat === "necessary"){ return; }
				this.checked = !!(data && data[cat]);
			});
		}

		function openCookiePrefs(){
			$cookieBar.find(".cookies-main").attr("hidden", true);
			$cookieBar.find(".cookies-prefs").removeAttr("hidden");
		}

		function closeCookiePrefs(){
			$cookieBar.find(".cookies-prefs").attr("hidden", true);
			$cookieBar.find(".cookies-main").removeAttr("hidden");
		}

		function showCookieNotification(){
			var a = $(".cookies-container", $cookieBar);
			$cookieBar.addClass("-show");
			gsap.from(a, {opacity:0, y:20, ease:Power3.easeOut, duration:0.5});
		}

		function hideCookieNotification(){
			var a = $(".cookies-container", $cookieBar);
			gsap.to(a, {opacity:0, y:20, ease:Power3.easeOut, duration:0.4});
			setTimeout(function(){
				$cookieBar.removeClass("-show");
				gsap.set(a, {opacity:1, y:0});
				closeCookiePrefs();
			}, 400);
		}

		function saveAll(value){
			var state = {};
			consentCats.forEach(function(cat){ state[cat] = value; });
			syncToggles(writeConsent(state));
			hideCookieNotification();
		}

		$cookieBar.on("click", "[data-consent-action]", function(){
			var action = $(this).attr("data-consent-action");

			if(action === "settings"){ openCookiePrefs(); return; }
			if(action === "accept"){ saveAll(true); return; }
			if(action === "reject"){ saveAll(false); return; }

			if(action === "save"){
				var state = {};
				$cookieBar.find("[data-consent-category]").each(function(){
					var cat = $(this).attr("data-consent-category");
					if(cat === "necessary"){ return; }
					state[cat] = this.checked;
				});
				writeConsent(state);
				hideCookieNotification();
			}
		});

		//Link in de footer om de keuze later te wijzigen of in te trekken.
		$("body").on("click", "[data-consent-open]", function(e){
			e.preventDefault();
			syncToggles(readConsent());
			openCookiePrefs();
			showCookieNotification();
		});

		var storedConsent = readConsent();
		if(storedConsent){
			applyConsent(storedConsent);
			syncToggles(storedConsent);
		}
		else{
			showCookieNotification();
		}

		//Kleine API voor eigen scripts: amsConsent.has("analytics")
		window.amsConsent = {
			get: function(){ return readConsent() || {v:consentVersion, necessary:true, analytics:false, marketing:false}; },
			has: function(cat){ var c = readConsent(); return !!(c && c[cat]); },
			set: function(state){ return writeConsent(state || {}); },
			open: function(){ syncToggles(readConsent()); openCookiePrefs(); showCookieNotification(); }
		};
	}


	$("body").on("click", "#book-button", function(e){
		//e.preventDefault();
		openBookingsModule();
	});

	$("body").on("click", ".booking_overlay .bg", function(e){
		//e.preventDefault();
		closeBookingsModule();
	});

	

	function openBookingsModule(){
		var html = $(".booking_box").html();
		$(".booking_overlay .el").html(html);
		$(".booking_overlay").addClass("-show");

		var this2 = $(".booking_box .booking_element");
		var y = $(this2).offset().top;
		var x = $(this2).offset().left;
		var w = $(this2).outerWidth();
		var h = $(this2).outerHeight();

		gsap.set($(".booking_overlay .booking_element"), {left:x,top:y,width:w,height:h});
		gsap.to($(".booking_overlay .booking_element"), {top:"5%",left:"5%", width:"90%", height:"90%", duration:1, delay:0, ease:Power3.easeInOut});
		gsap.to($(".booking_overlay .bg"), {opacity:1, duration:1.5, delay:0, ease:Power3.easeInOut});
	}

	function closeBookingsModule(){
		var html = $(".booking_overlay .el .booking_element").html();
		$(".booking_box").html('<div class="booking_element">'+html+'</div>');

		setTimeout(function(){
			$(".booking_overlay").removeClass("-show");
		},600);

		var this2 = $(".booking_box .booking_element");
		var y = $(this2).offset().top;
		var x = $(this2).offset().left;
		var w = $(this2).outerWidth();
		var h = $(this2).outerHeight();
		gsap.to($(".booking_overlay .booking_element"), {top:y,left:x, width:w, height:h, background:"rgba(255,255,255,0)",duration:0.6, delay:0, ease:Power3.easeInOut});
		gsap.to($(".booking_overlay .bg"), {opacity:0, duration:0.6, delay:0, ease:Power3.easeInOut});
	}




	

	//SLIDER
	function initSliders(){
		if($(".slider").length > 0){
			///DRAGGABLE SLIDER
			$(".slider").each(function(i,v){
				var container = $(this).parent();
				var nSlides = $(".slide", this).length;
				var slideWidth = $(".slide", this).width();

				var sliderWidth = nSlides*slideWidth;
				$(this).width(sliderWidth);
				Draggable.create(this, {
					edgeResistance: 0.85,
					type: "x",
					inertia: true,
			    	autoScroll: true,
					bounds: container,
					throwProps:true, 
					onMove: function(a) {
						sliderParallax(this);
						
					},
					onThrowUpdate: function(){
						sliderParallax(this);
					},
					onDragEnd: function() {
						sliderParallax(this);
					}
				});
			});

		}
	}

	function sliderParallax(slider){
		var y = locoScroll.scroll.instance.scroll.y;
		var x = locoScroll.scroll.instance.scroll.x;
		lazyLoad(y,x);
		var sliderX = slider.x*-1;
		var sliderEl = $(slider.target)[0];
		var sliderID = $(sliderEl).attr("data-slider-id");
		var sliderButtonsEl = $("[data-slider-id-buttons='"+sliderID+"'");
		var sliderWidth = $(slider.target).width();
		var sliderContainerWidth = $(slider.target).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;

		if(sliderX > 0){
			$(".-prev.-disabled", sliderButtonsEl).removeClass("-disabled");
		}
		if(sliderX < 0){
			$(".-prev:not(.-disabled)", sliderButtonsEl).addClass("-disabled");
		}

		if(sliderX+sliderContainerWidth > sliderWidth){
			$(".-next:not(.-disabled)", sliderButtonsEl).addClass("-disabled");
		}
		if(sliderX+sliderContainerWidth < sliderWidth){
			$(".-next.-disabled", sliderButtonsEl).removeClass("-disabled");
		}
		

		/*var sliderWidth = $(slider.target).width();
		var slides = $(".slide", slider.target).length;
		var slideWidth = sliderWidth/slides;
		console.log(slideWidth);
		var absSlidePos = -(Math.ceil(slider.x/slideWidth))+1;
		var relSlidePerc = Math.abs(slider.x/slideWidth)-(absSlidePos-1);
		var relSlidePercEase = easeInCubic(relSlidePerc);
		$(".slide:nth-child("+absSlidePos+")", slider.target).css({"transform": "translate("+(-relSlidePercEase*20)+"%, 0)"});*/
	}

	$("body").on("click", ".slider-buttons .slider-button.-next:not(.-disabled)", function(e){
		var sliderButtonsEl = $(this).parent("[data-slider-id-buttons]");
		$(".-prev.-disabled", sliderButtonsEl).removeClass("-disabled");
		var sliderID = $(sliderButtonsEl).attr("data-slider-id-buttons");
		var sliderEl = $("[data-slider-id='"+sliderID+"'");
		var sliderX = $(sliderEl).position().left*-1;
		var sliderWidth = $(sliderEl).width();
		var sliderContainerWidth = $(sliderEl).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;
		var currentSlide = Math.floor(sliderX/slideWidth);
		var nextSlide = currentSlide+1;
		var nextPos = (nextSlide)*slideWidth;
		if(nextPos > (sliderWidth-sliderContainerWidth)){
			nextPos = sliderWidth-sliderContainerWidth;
			$(this).addClass("-disabled");
		}
		gsap.to(sliderEl, {x:-nextPos,duration:1,ease:Power3.easeInOut});
	});
	


	$("body").on("click", ".slider-buttons .slider-button.-prev:not(.-disabled)", function(e){
		var sliderButtonsEl = $(this).parent("[data-slider-id-buttons]");
		$(".-next.-disabled", sliderButtonsEl).removeClass("-disabled");
		var sliderID = $(sliderButtonsEl).attr("data-slider-id-buttons");
		var sliderEl = $("[data-slider-id='"+sliderID+"'");
		var sliderX = $(sliderEl).position().left*-1;
		var sliderWidth = $(sliderEl).width();
		var sliderContainerWidth = $(sliderEl).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;
		var currentSlide = Math.ceil(sliderX/slideWidth);
		var nextSlide = currentSlide-1;
		var nextPos = (nextSlide)*slideWidth;
		if(nextPos <= 0){
			nextPos = 0;
			$(this).addClass("-disabled");
		}
		//console.log(sliderX, nextPos, sliderWidth, sliderContainerWidth, currentSlide);
		gsap.to(sliderEl, {x:-nextPos,duration:1,ease:Power3.easeInOut});
	});


	$(document).on('click', '.player-button', function () {
		const $container = $(this).closest('.video-container');
		const video = $container.find('video').get(0);
		const videoEl = $container.find('.video').get(0);
		const afterEl = $container.find('.after').get(0);
		const textEl = $container.find('.text').get(0);
		const playerButtonEl = $container.find('.player-button').get(0);
		

		if (!video) return;

		if (video.paused) {
			video.play();
			$container.addClass('playing');
			gsap.to(videoEl, {opacity:1});
			gsap.to(afterEl, {opacity:0, "pointer-events":"none", delay:0.6});
			gsap.to(textEl, {opacity:0, y:30, delay:0});
			gsap.to(playerButtonEl, {opacity:0, duration:0.4, delay:0, ease:Power3.easeOut});
		} else {
			video.pause();
			$container.removeClass('playing');
		}
	});
	function pauseVideo($container) {

		const videoEl = $container.find('.video').get(0);
		const afterEl = $container.find('.after').get(0);
		const textEl = $container.find('.text').get(0);
		const playerButtonEl = $container.find('.player-button').get(0);
		$container.removeClass('playing');
		gsap.to(videoEl, { opacity: 1 });
		gsap.to(afterEl, { opacity: 1, "pointer-events": "all" });
		gsap.to(textEl, { opacity: 1, y: 0 });
		gsap.to(playerButtonEl, {
			opacity: 1,
			duration: 0.4,
			ease: Power3.easeOut
		});

	}

	$('body').find('.video-container video').each(function () {
		$(this).on('pause', function () {
			pauseVideo($(this).closest('.video-container'));
		});
	});


	function initCarAnimation() {

		const canvas = document.querySelector(".car-animation");

		if (!canvas) {
			return;
		}


		const ctx = canvas.getContext("2d");

		const frameCount = parseInt(canvas.dataset.frameCount);
		const imagePath = canvas.dataset.imagePath;

		const images = [];
		let imagesLoaded = 0;
		let currentFrame = 0;


		function getFramePath(index) {
			return `${imagePath}20141222_000${index}.png`;
		}


		function resizeCanvas() {
			const firstImage = images[0];
			if (!firstImage) return;
			const ratio = firstImage.width / firstImage.height;
			canvas.width = canvas.offsetWidth;
			canvas.height = canvas.width / ratio;
			renderFrame(currentFrame);
		}


		function renderFrame(index) {
			const image = images[index];
			if (!image) return;
			ctx.clearRect(
				0,
				0,
				canvas.width,
				canvas.height
			);

			ctx.drawImage(
				image,
				0,
				0,
				canvas.width,
				canvas.height
			);
		}


		// Frames preloaden
		for (let i = 1; i <= frameCount; i++) {
			const img = new Image();
			img.onload = () => {
				imagesLoaded++;
				if (imagesLoaded === frameCount) {
					resizeCanvas();
					window.addEventListener(
						"resize",
						resizeCanvas
					);
				}
			};
			img.src = getFramePath(i);
			images.push(img);
		}


		ScrollTrigger.create({
			trigger: canvas.closest(".flex-3d_model"),
			scroller: ".scroller",
			start: "top bottom",
			end: "bottom top",
			scrub: true,
			onUpdate: (self) => {
				if (imagesLoaded !== frameCount) {
					return;
				}

				const frame = Math.floor(
					self.progress * (frameCount - 1)
				);

				if (frame !== currentFrame) {
					currentFrame = frame;
					renderFrame(currentFrame);
				}
			}
		});

	}



	



    
    function initPage(){
        
        initScroll();
		//initNav();
		initSliders();

	
    }
    initPage();


	function easeInCubic(x){
		return x * x * x;
	}
	

} ) ( jQuery );




